import { render, staticRenderFns } from "./numCount.vue?vue&type=template&id=3016feca&scoped=true"
import script from "./numCount.vue?vue&type=script&lang=js"
export * from "./numCount.vue?vue&type=script&lang=js"
import style0 from "./numCount.vue?vue&type=style&index=0&id=3016feca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3016feca",
  null
  
)

export default component.exports